import type { GameCredentials, GameView, Session } from "./types";

const SESSIONS_KEY = "vorstenduel.sessions.v1";
const snapshotKey = (gameId: string) => `vorstenduel.snapshot.${gameId}`;

export function sessions(): Session[] {
  try {
    const value = JSON.parse(localStorage.getItem(SESSIONS_KEY) || "[]") as Session[];
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
}

export function saveCredentials(credentials: GameCredentials): Session {
  const session: Session = {
    gameId: credentials.game_id,
    token: credentials.player_token,
    seat: credentials.seat,
    joinCode: credentials.join_code || undefined,
    savedAt: Date.now(),
  };
  const next = [session, ...sessions().filter((item) => item.gameId !== session.gameId)].slice(0, 12);
  localStorage.setItem(SESSIONS_KEY, JSON.stringify(next));
  return session;
}

export function getSession(gameId: string): Session | undefined {
  return sessions().find((session) => session.gameId === gameId);
}

export function forgetSession(gameId: string): void {
  localStorage.setItem(SESSIONS_KEY, JSON.stringify(sessions().filter((session) => session.gameId !== gameId)));
  localStorage.removeItem(snapshotKey(gameId));
}

export function saveSnapshot(gameId: string, game: GameView): void {
  localStorage.setItem(snapshotKey(gameId), JSON.stringify({ game, savedAt: Date.now() }));
}

export function loadSnapshot(gameId: string): { game: GameView; savedAt: number } | undefined {
  try {
    const value = JSON.parse(localStorage.getItem(snapshotKey(gameId)) || "null");
    return value?.game ? value : undefined;
  } catch {
    return undefined;
  }
}
